/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {isDevelopment, isInfo} from 'env-var-helpers';

// Activate mobx devtools
import DevTools, {
    configureDevtool,
    setLogEnabled,
    setUpdatesEnabled,
    setGraphEnabled,
} from 'mobx-react-devtools';

/**************************************** TYPE DEFINITIONS ****************************************/
/**
 * Sent to MobX devtools every time a MobX event occurs e.g. "add", "action"
 */
interface MobXChangeEvent {
    name: string;
    object?: {name: string};
    spyReportStart: boolean;
    type: string;
}

/******************************************** HELPERS *********************************************/
/**
 * Don't log language-related updates, they produce a lot of clutter
 */
const blockAddLangEvent = (change: MobXChangeEvent): boolean => {
    const isChangeCurrentLang = change.name === 'currentLang';
    const isLangObj = change.object && change.object.constructor.name === 'Lang';
    const isAdd = change.type === 'add';
    return !isInfo && !(isChangeCurrentLang && isLangObj && isAdd);
};

/********************************************* CONFIG *********************************************/
/**
 * Ensure devtool runs only once
 */
let isConfigured = false;

/********************************************* EXPORT *********************************************/
/**
 * Builds the MobX developer tool, but only in dev mode
 */
export const MobxDevtool = () => {
    /*
     * Configure the dev tool - run only once
     */
    if (isDevelopment && !isConfigured) {
        configureDevtool({
            logEnabled: true,
            logFilter: blockAddLangEvent,
            updatesEnabled: true,
            graphEnabled: true,
        });
        setLogEnabled(false);
        setUpdatesEnabled(false);
        setGraphEnabled(false);
        isConfigured = true;
    }
    return isDevelopment ? <DevTools position={{bottom: 0, left: 40}} /> : null;
};

MobxDevtool.displayName = `MobxDevtool`;
